import React from "react";
import Paper from "./Paper";
import Styled from "./styles";

const paperStyle = style => ({
  width: "100%",
  fontFamily: "Lato",
  fontSize: "16px",
  ...style
});

const OnePanel = ({ title, style, children }) => (
  <Paper style={paperStyle(style)}>
    <Styled.Title>{title}</Styled.Title>
    {children}
  </Paper>
);

export default OnePanel;



// WEBPACK FOOTER //
// ./src/components/bcase/OnePanel.js